import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouteParameter } from '@biletix/core/common/constants/route-parameter.const';
import { PastPerformancesByArtist } from '@biletix/core/models/event/past-performances-by-artist.model';
import { EventService } from '@biletix/core/services/event.service';
import { DatePipe } from '@angular/common';

@Component({
  standalone: false,
  selector: 'btx-artist-past-performances',
  templateUrl: './artist-past-performances.component.html',
  styleUrls: ['./artist-past-performances.component.scss']
})
export class ArtistPastPerformancesComponent implements OnInit {
  allPastPerformances: PastPerformancesByArtist[] = [];
  pastPerformances: PastPerformancesByArtist[] = [];
  loading = true;
  error: string | null = null;

  displayLimit = 5;
  incrementAmount = 5;
  viewMode: 'grid' | 'list' = 'grid';

  constructor(
    private eventService: EventService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.loadPastPerformances();
  }

  loadPastPerformances(): void {
    const artistCode = this.activatedRoute.snapshot.params[RouteParameter.PARAMS.ARTIST_CODE];

    if (artistCode) {
      this.eventService.getPastPerformancesDetailByArtist(artistCode)
        .subscribe(
          (data) => {
            this.allPastPerformances = data.sort((a, b) => b.performanceDate - a.performanceDate);
            this.updateDisplayedPerformances();
            this.loading = false;
          },
          (error) => {
            console.error('Error loading past performances:', error);
            this.error = 'Geçmiş etkinlikler yüklenirken bir hata oluştu.';
            this.loading = false;
          }
        );
    } else {
      this.error = 'Sanatçı kodu bulunamadı.';
      this.loading = false;
    }
  }

  updateDisplayedPerformances(): void {
    this.pastPerformances = this.allPastPerformances.slice(0, this.displayLimit);
  }

  showMoreItems(): void {
    this.displayLimit += this.incrementAmount;
    this.updateDisplayedPerformances();
  }

  get hasMoreItems(): boolean {
    return this.displayLimit < this.allPastPerformances.length;
  }

  formatDate(timestamp: number): string {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return this.datePipe.transform(date, 'dd.MM.yyyy') || '';
  }

  getTime(timestamp: number): string {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return this.datePipe.transform(date, 'HH:mm') || '';
  }

  getDayFromTimestamp(timestamp: number): string {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.getDate().toString();
  }

  getMonthNameFromTimestamp(timestamp: number): string {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const monthNames = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
                         'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    return monthNames[date.getMonth()];
  }

  getDayNameFromTimestamp(timestamp: number): string {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const dayNames = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
    return dayNames[date.getDay()];
  }

  toggleViewMode(mode: 'grid' | 'list'): void {
    this.viewMode = mode;
  }
}
